import React, { useState } from 'react'

import { useGetAllNotifications } from '../../redux/company/hook'
import DataTable from '../datatable'
import { PAGINATION_DEFAULT } from '../../utils/constants'

const AllNotifications = () => {
  const [pagination, setPagination] = useState({
    limit: PAGINATION_DEFAULT.limit,
    page: PAGINATION_DEFAULT.page,
    search: '',
  })

  const { data: allNotifications } = useGetAllNotifications(
    pagination?.limit,
    pagination?.page,
    pagination?.search
  )

  const tableConfig = {}

  return (
    <div>
      <DataTable
        data={allNotifications}
        tableConfig={tableConfig}
        updatePagination={(data) => setPagination(data)}
        computedActions={true}
        tableType={'notifications'}
      />
    </div>
  )
}

export default AllNotifications
